import { Translations } from './pl';

const de: Translations = {
    header: {
        products: 'Produkte',
        about: 'Über uns',
        contact: 'Kontakt',
        cart: 'Warenkorb',
        transactionList: 'Transaktionsliste',
        manageProducts: 'Produkte verwalten',
        manageCategories: 'Kategorien verwalten',
        changePassword: 'Passwort ändern',
    },
    cart: {
        title: 'im Warenkorb',
        order: 'Bestellen',
        item: 'Artikel',
        items_2_4: 'Artikel',
        items_5plus: 'Artikel',
    },
    home: {
        subtitle: 'Professionelle Aluminium-Lösungen für Gärten, Beleuchtung und Landschaftsarchitektur.',
        button: 'Mehr erfahren',
        listTitle: 'Angebotsliste',
    },
    footer: {
        terms: 'AGB',
        returnPolicy: 'Rückgabe- und Reklamationsrichtlinien',
    },
    contact: {
        title: 'Kontaktieren Sie uns',
        subtitle: 'Wir sind hier, um alle Ihre Fragen zu beantworten',
        callUs: 'Rufen Sie uns an',
        callDesc: 'Wenn Sie sofortige Hilfe benötigen oder mit uns sprechen möchten, sind wir von Montag bis Freitag erreichbar.',
        writeUs: 'Schreiben Sie uns',
        writeDesc: 'Haben Sie Fragen oder benötigen Sie Hilfe? Kontaktieren Sie uns per E-Mail und wir antworten so schnell wie möglich.',
        hours: 'Öffnungszeiten',
        weekdays: 'Montag - Freitag',
        address: 'Adresse',
        readyTitle: 'Bereit zur Zusammenarbeit?',
        readyText: 'Egal ob Sie Fragen zu unseren Produkten haben, Hilfe bei einer Bestellung benötigen oder einfach nur reden möchten - wir sind für Sie da.',
        callNow: 'Jetzt anrufen',
        sendEmail: 'E-Mail senden',
        formTitle: 'Nachricht senden',
        formSubtitle: 'Füllen Sie das Formular aus, wir antworten so schnell wie möglich',
        formName: 'Vor- und Nachname',
        formNamePlaceholder: 'Max Mustermann',
        formEmail: 'E-Mail-Adresse',
        formEmailPlaceholder: 'max@beispiel.de',
        formPhone: 'Telefon (optional)',
        formPhonePlaceholder: '+49 000 000 000',
        formSubject: 'Betreff',
        formSubjectPlaceholder: 'Produktanfrage',
        formMessage: 'Nachricht',
        formMessagePlaceholder: 'Beschreiben Sie Ihre Frage oder Anfrage...',
        formSubmit: 'Nachricht senden',
        formSending: 'Wird gesendet...',
        formSuccess: 'Nachricht gesendet! Wir antworten so schnell wie möglich.',
        formError: 'Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
        formErrorRequired: 'Dieses Feld ist erforderlich',
        formErrorEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    },
    aboutUs: {
        title: 'Über uns',
        subtitle: 'Wir gestalten seit über 3 Jahren Aluminium-Kleinarchitektur',
        whatWeDoTitle: 'Was machen wir?',
        whatWeDoDesc: 'Wir sind Hersteller von Aluminium-Kleinarchitekturelemente und bieten hochwertige Lösungen für die vielfältigen Bedürfnisse unserer Kunden.',
        mastsTitle: 'Masten',
        mastsDesc: 'Für Kameras und Beleuchtung',
        lampsTitle: 'Gartenlampen',
        lampsDesc: 'Moderne LED-Beleuchtung',
        lamelTitle: 'Fassadenlamellen',
        lamelDesc: 'Ästhetische Verkleidungen',
        pergolasTitle: 'Pergolen und Rankgitter',
        pergolasDesc: 'Gartengitter',
        constructionsTitle: 'Konstruktionen',
        constructionsDesc: 'Terrassen und Überdachungen',
        yearsLabel: 'Jahre Erfahrung',
        alumLabel: 'Aluminium',
        possLabel: 'Möglichkeiten',
        missionTitle: 'Unsere Mission',
        missionText: 'Unsere Produkte findet man nicht nur bei Privatkunden, sondern auch in Schulen, Ämtern und Einkaufszentren. Wir erweitern ständig unser Leistungsangebot und führen neue Lösungen ein, wobei wir stets auf höchste Qualität achten.',
    },
    product: {
        categories: 'Kategorien',
        height: 'Höhe',
        price: 'Preis',
        quantity: 'Menge',
        addToCart: 'In den Warenkorb',
        shipping: 'Versand',
        perPiece: '/Stk.',
        imageUnavailable: 'Vorschau vorübergehend nicht verfügbar',
        previewUnavailable: 'Vorschau derzeit nicht verfügbar',
        from: 'ab',
        warning: 'Achtung',
        downloads: 'Downloads',
        declarationOfConformity: 'Konformitätserklärung',
        declarationOfConformityDesc: 'Dokument zur Bestätigung der Übereinstimmung des Produkts mit EU-Normen',
        productCard: 'Produktdatenblatt',
        productCardDesc: 'Detaillierte technische Spezifikation des Produkts',
        download: 'Herunterladen',
        attention: [
            'Elektrische Anschlussarbeiten müssen von einem Fachmann mit entsprechenden Qualifikationen durchgeführt werden.',
            'Ein korrekt montiertes Gerät darf nur an eine funktionsfähige elektrische Anlage angeschlossen werden.',
            'Es ist verboten, ein Gerät mit sichtbaren Schäden am Gehäuse oder am Netzkabel zu montieren.',
            'Das Produkt ist für die Montage außerhalb von Gebäuden bestimmt.',
            'Vor der Montage muss die Stromversorgung getrennt und die Sicherheitsvorschriften eingehalten werden.',
        ],
        labels: [
            {
                src: 'https://dl37p4knu94gw.cloudfront.net/Śmietnik.png',
                text: 'Elektrische Geräte, die mit dem Symbol der durchgestrichenen Mülltonne gekennzeichnet sind, dürfen nicht mit dem Hausmüll entsorgt werden. Solche Geräte unterliegen der Sammlung und dem Recycling.',
            },
            {
                src: 'https://dl37p4knu94gw.cloudfront.net/Uziemienie.png',
                text: 'Gerät mit Schutzleiter. Blau - N; Braun – L; Gelb-Grün – Erdung',
            },
            {
                src: 'https://dl37p4knu94gw.cloudfront.net/cece.png',
                text: 'Erfüllt die Anforderungen der Neuen-Ansatz-Richtlinien der Europäischen Union.',
            },
        ],
    },
    categories: {
        breadcrumb: 'Kategorien',
        currentOffers: 'Aktuell verfügbare Angebote',
    },
    checkout: {
        title: 'Bestellung',
        shippingSection: 'Lieferadresse',
        billSection: 'Rechnungsdaten',
        orderSummary: 'Ihre Bestellung',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail',
        phone: 'Telefon',
        address: 'Adresse',
        city: 'Stadt',
        postalCode: 'Postleitzahl',
        country: 'Land',
        notes: 'Anmerkungen zur Bestellung',
        wantInvoice: 'Ich möchte eine MwSt.-Rechnung',
        cod: 'Nachnahme',
        codBlocked: 'Nachnahme ist für Produkte mit einer Höhe von 5 m oder mehr nicht verfügbar.',
        companyName: 'Firmenname',
        fullAddress: 'Vollständige Adresse',
        submit: 'Bestellung aufgeben',
        submitOrder: 'Bestellen und bezahlen',
        summary: 'Zusammenfassung',
        total: 'Gesamt',
        shipping: 'Versand',
        shippingCost: 'Versandkosten',
        quantity: 'Menge',
        errors: {
            nameRequired: 'Vorname ist erforderlich',
            surnameRequired: 'Nachname ist erforderlich',
            emailRequired: 'E-Mail ist erforderlich',
            emailInvalid: 'E-Mail ist ungültig',
            phoneRequired: 'Telefonnummer ist erforderlich',
            phoneInvalid: 'Telefonnummerformat ist ungültig',
            addressRequired: 'Adresse ist erforderlich',
            cityRequired: 'Stadt ist erforderlich',
            zipRequired: 'Postleitzahl ist erforderlich',
            zipInvalid: 'Postleitzahl ist ungültig',
            companyRequired: 'Firmenname ist erforderlich',
            nipRequired: 'USt-IdNr. ist erforderlich',
            nipInvalid: 'USt-IdNr. ist ungültig',
        },
    },
    success: {
        title: 'Vielen Dank für Ihren Einkauf!',
        subtitle: 'Die Bestellung wurde aufgegeben und bezahlt. Die Bestellbestätigung und Details wurden per E-Mail gesendet. Falls Sie keine E-Mail erhalten haben, überprüfen Sie bitte Ihren Spam-Ordner. Mit freundlichen Grüßen, Expo Aluminium.',
    },
    cancel: {
        title: 'Bestellung wurde storniert.',
        subtitle: 'Sie haben die Bestellung storniert oder es ist ein Fehler bei der Zahlung aufgetreten.',
        shopLinkText: 'Wenn Sie erneut bestellen möchten, gehen Sie zum',
        shopLink: 'Shop',
    },
    notFound: {
        title: 'Seite nicht gefunden',
        subtitle: 'Entschuldigung, diese Seite existiert nicht',
        home: 'Startseite',
    },
    common: {
        loading: 'Wird geladen...',
        error: 'Ein Fehler ist aufgetreten',
        back: 'Zurück',
    },
};

export default de;
